<template>
  <header class="header">
    <div class="container">
      <div class="header__logos">
<!--        <a class="header__logo" href="https://royalcanin.ru/">-->
<!--          <img class="header__logo-img header__logo-img&#45;&#45;royal" src="/static/img/logo/royal.svg">-->
<!--        </a>-->
        <a class="header__logo" 
           href="https://zoozavr.ru/"
           onclick="sendEventYM(
             102182679,
             'logo_zoozavr_click_btn'
           );">
          <img class="header__logo-img header__logo-img--zoozavr" src="/static/img/logo/zoozavr.png">
        </a>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
}
</script>

<style lang="scss">
.header {
  padding: 9.5px 0;
  height: $header;
  background-color: var(--white);
  border-bottom: 1px solid var(--light-gray);

  @media (min-width: $lg) {
    padding: 10px 0;
    height: 68px;
  }

  &__logos {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin: 0 auto;
    width: 172px;
  }

  &__logo {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 49px;

    //&:nth-child(2) {
    //  position: relative;
    //
    //  &::before {
    //    content: "";
    //    position: absolute;
    //    top: 0;
    //    left: -8px;
    //    width: 1px;
    //    height: 100%;
    //    background-color: var(--light-gray);
    //  }
    //}

    &-img {
      &--royal {
        width: 77px;
        height: 26px;
      }

      &--zoozavr {
        width: 79px;
      }
    }
  }
}
</style>
